import { Box, Divider, Typography } from '@mui/material'
import React from 'react'

function CardRow({fontColor,title,value }) {
    return (
        <Box
            sx={{
                cursor: 'pointer',
                display: 'flex', // Keep flex display
                flexDirection: 'row', // Keep row direction
                // alignItems: 'center', // Change this from 'center'
                alignItems: 'stretch', // Use 'stretch' to make children fill height
                
                width: '100%',
                padding:'5px'
                // to ensure the Box has height for the divider to fill
            }}
        >
            <Typography
                sx={{
                    fontFamily: 'Cairo',
                    color: fontColor,
                    fontSize: '14px',
                    fontWeight:'800',
                    textAlign: 'center',
                    flex: 1, // Takes up 1 part of the space
                    direction: 'rtl',
                    display: 'flex',       // Added to allow vertical centering
                    alignItems: 'center',  // Vertically center text within its own space
                    justifyContent: 'center', // Horizontally center text
                }}
            >
                {title}
            </Typography>

            {/* Vertical Divider */}
            <Divider
                orientation="vertical"
                flexItem // Crucial: Allows the divider to inherit flex container alignment

                sx={{
                    mx: 2, // Horizontal margin for spacing
                    borderColor: 'black', // Explicitly set the border color to black
                    borderRightWidth: 2, // Set thickness (optional, default is 1)
                    height: 'auto !important'
                    // Remove height: '100%', let alignItems: 'stretch' handle it
                }}
            />

            <Typography
                sx={{
                    fontFamily: 'Cairo',
                    color: fontColor,
                    fontSize: '14px',
                    textAlign: 'center',
                    flex: 2, // Takes up 2 parts of the space
                    direction: 'ltr',
                    display: 'flex',       // Added to allow vertical centering
                    alignItems: 'center',  // Vertically center text within its own space
                    justifyContent: 'center', // Horizontally center text
                }}
            >
                {value}
            </Typography>
        </Box>


    )
}

export default CardRow